/**
 * Просьба «открой шторку Agapella» из любого экрана.
 *
 * Плавающая Agapella смонтирована в `App.tsx` рядом с навигатором, а открыта ли
 * шторка, знает только она сама. Экрану, который хочет её открыть (например,
 * «Подобрать с ИИ» под каталогом практик), родителя общего с ней нет — поэтому
 * канал живёт вне React-дерева, как `reservedZones`.
 *
 * Виджет отвечает, открыл ли он шторку: на экранах, где лончер скрыт, и когда
 * виджета нет вовсе, он не отвечает `true` — вызывающий в этом случае делает
 * запасной переход (например, в полный чат).
 */
type Opener = () => boolean;

const openers = new Set<Opener>();

/** Виджет подписывается, пока смонтирован; возвращает отписку. */
export function onWidgetOpenRequest(opener: Opener): () => void {
  openers.add(opener);
  return () => {
    openers.delete(opener);
  };
}

/** Попросить открыть шторку. `true` — виджет открыл её; `false` — открывать нечему. */
export function requestOpenAgapellaWidget(): boolean {
  let opened = false;
  openers.forEach((opener) => {
    if (opener()) opened = true;
  });
  return opened;
}
